import React from 'react';

import { PartnerLink } from '@components/admin/widgets/PartnerLink';
import { TextInput } from '@components/NextForms/TextInput';
import { CustomsRequestSubmissionTarget } from '@models/next/CustomsRequest';
import { MobxZodField } from '@monoid-dev/mobx-zod-form';
import { ZodString } from 'zod';

interface CustomsRequestSubmissionTargetInputProps {
  field: MobxZodField<ZodString>;
  placeholder?: string;
  submissionTargets: CustomsRequestSubmissionTarget[];
}

export const CustomsRequestSubmissionTargetInput: React.FC<
  CustomsRequestSubmissionTargetInputProps
> = (props) => {
  const { field, submissionTargets, placeholder } = props;
  return (
    <TextInput
      field={field}
      inputProps={{ placeholder }}
      inputOptions={{
        type: 'choose',
        options: submissionTargets.map(({ company, id }) => ({
          label: company,
          value: company,
          labelIcon: id && <PartnerLink partnerId={id} />,
        })),
      }}
    />
  );
};
